const article = {
    slug: "first_comme_des_garcons_homme_plus_experience",
    category: "BRAND ENTRY",
    title: "初めてのCOMME des GARÇONS HOMME PLUSをレンタル体験",
    listDescription:
      "テーラリングを壊し、身体の見え方を変える。COMME des GARCONS HOMME PLUSを“着ること”から理解する入口ページ。",
    seo: {
      title:
        "初めてのコムデギャルソンオムプリュスをレンタル体験｜COMME des GARCONS HOMME PLUSを着て知るEnclopedia",
      description:
        "COMME des GARÇONS HOMME PLUSが気になるけれど、どんなブランドか分からない方へ。コムデギャルソンオムプリュスの魅力、テーラリングの再構成、縮絨・再構築・コレクション性を分かりやすく解説し、Enclopediaでレンタルできるアーカイブへ案内します。",
      keyword:
        "初めてのコムデギャルソンオムプリュス,コムデギャルソンオムプリュス 初めて,オムプリュス 初めて,COMME des GARCONS HOMME PLUS 初めて,コムデギャルソンオムプリュス とは,オムプリュス どんなブランド,HOMME PLUS どんなブランド,コムデギャルソンオムプリュス レンタル,HOMME PLUS レンタル,オムプリュス 着てみたい,コムデギャルソンオムプリュス アーカイブ,HOMME PLUS アーカイブ,enclopedia,アンクロペディア",
      canonicalPath:
        "/archive_guide/first_comme_des_garcons_homme_plus_experience",
    },
    hero: {
      label: "FIRST COMME des GARCONS HOMME PLUS EXPERIENCE",
      number: "04 / ENTRY",
      titleLines: [
        "初めての",
        "COMME des GARÇONS HOMME PLUSをレンタル体験。",
      ],
      body:
        "コムデギャルソン オムプリュスは、\n“メンズ服らしさ”を守るブランドではなく、\nテーラード、パンツ、身体の輪郭を更新し続けるブランドです。\n初めて知るなら、まずは“着ることで分かる違和感”から入るのが自然です。",
      keywords: [
        "first experience",
        "tailoring",
        "body",
        "homme plus",
      ],
      visualLabel: "ARCHIVE EXPERIENCE",
      visualTitle: [
        "普通のメンズ服が、",
        "なぜここまで変わるのか。",
      ],
      image: "media/archive_fashion/archive_guide3.png",
      imageAlt:
        "初めてのCOMME des GARÇONS HOMME PLUSをレンタル体験するためのアーカイブガイド画像",
      ctaLabel: "レンタルできるCOMME des GARCONS HOMME PLUSを見る",
      ctaHref:
        "https://www.enclopedia-official.com/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
    },
    thesis: {
      text:
        "COMME des GARCONS HOMME PLUSは、男性服を飾るのではなく、男性服の前提そのものを組み替えるブランドです。",
      keywords: ["menswear", "reconstruction", "experience"],
    },
    sections: {
      whyThisPage: {
        label: "02 / WHY THIS PAGE?",
        titleLines: [
          "COMME des GARCONS HOMME PLUSが気になる。",
          "でも、どこが特別なのか説明しづらい。",
        ],
        body:
          "COMME des GARÇONS HOMME PLUSは、ファッション好きの間では強く評価される一方、初めて見る人には“少し難しい服”に映ることがあります。\nしかし、その魅力は専門知識がないと分からないものではありません。\nテーラードジャケット、パンツ、シャツといった見慣れた男性服が、少しずつ壊され、ずらされ、再構成されている。その変化を着ることで理解するための入口が、このページです。",
      },
  
      brandOverview: {
        label: "03 / BRAND OVERVIEW",
        titleLines: [
          "男らしさを強調するのではなく、",
          "男性服の型を問い直す。",
        ],
        body:
          "COMME des GARCONS HOMME PLUSは、1984年に始まったコムデギャルソンのメンズコレクションラインです。\nジャケット、パンツ、スーツ、コートといった男性服の基本形を出発点にしながら、縮絨、再構築、極端な分量、非対称、装飾、柄の衝突を通して、その“普通”を更新してきました。\nだからこそ、COMME des GARCONS HOMME PLUSは単なるメンズブランドではなく、男性服の見え方を変えるコレクションとしてアーカイブで語られ続けています。",
        knowledgeItems: [
          {
            title: "テーラードは、整えるためだけの服ではない。",
            text:
              "COMME des GARCONS HOMME PLUSでは、ジャケットが身体を端正に見せるだけでなく、膨らませ、ずらし、時には歪ませることで、着る人の輪郭そのものを変えます。",
          },
          {
            title: "縮絨・再構築は、装飾ではなく思想の可視化。",
            text:
              "生地を縮ませる、複数の衣服を接続する、既存の形を崩す。こうした技法は“変わったデザイン”ではなく、既成概念を疑う姿勢として現れます。",
          },
          {
            title: "毎シーズン、服に問いがある。",
            text:
              "COMME des GARCONS HOMME PLUSは、コレクションごとにテーマが明確です。花、少年性、宗教性、光、ジェンダー、歴史。服はテーマの説明ではなく、その問いの造形として現れます。",
          },
          {
            title: "アーカイブが面白いのは、変化を比較できるから。",
            text:
              "90年代、2000年代、近年作では、同じCOMME des GARCONS HOMME PLUSでも表現が違います。過去作を追うと、男性服の更新がどのように積み重なったかが見えてきます。",
          },
        ],
      },
  
      lineGuide: {
        label: "04 / HOW TO SEE COMME des GARCONS HOMME PLUS?",
        titleLines: [
          "COMME des GARCONS HOMME PLUSを見るなら、",
          "まず4つの視点から。",
        ],
        items: [
          {
            tag: "ENTRY 01",
            title: "TAILORING",
            text:
              "ジャケットやスーツをどう崩し、どう再構成しているか。COMME des GARCONS HOMME PLUSを読む最初の視点です。",
          },
          {
            tag: "ENTRY 02",
            title: "BODY & PROPORTION",
            text:
              "身体をスマートに整えるのではなく、肩、背中、裾、パンツの分量を変えて、存在感そのものを作ります。",
          },
          {
            tag: "ENTRY 03",
            title: "MATERIAL & PROCESS",
            text:
              "縮絨、パッチワーク、ブリーチ、ドッキング。素材や加工は、シーズンの思想を服に定着させる手段になります。",
          },
          {
            tag: "ENTRY 04",
            title: "COLLECTION THEME",
            text:
              "コレクションのテーマを見ると、単体では奇抜に見える服が、全体の流れの中で理解しやすくなります。",
          },
        ],
      },
  
      firstExperience: {
        label: "05 / FIRST EXPERIENCE",
        titleLines: ["初めて着ると、", "何が分かるのか。"],
        intro:
          "COMME des GARCONS HOMME PLUSは、写真で見て“強い服”に感じても、身体に乗せるとその構造の理由が見えやすくなるブランドです。",
        items: [
          {
            index: "01",
            title: "ジャケットなのに、身体の見え方が変わる",
            text:
              "肩幅、着丈、襟、身頃の膨らみ。わずかな構造の違いで、普通のテーラードとは異なる重心が生まれます。",
          },
          {
            index: "02",
            title: "パンツの分量が、歩き方まで変える",
            text:
              "ワイド、サルエル、極端なシルエット。COMME des GARCONS HOMME PLUSではパンツも単なる下半身の服ではなく、全体の造形を支える重要な要素です。",
          },
          {
            index: "03",
            title: "コレクションのテーマが、着た瞬間に立ち上がる",
            text:
              "花柄、光沢、装飾、重なり。単品で見たときより、身体に乗せたときのほうが、シーズンの意図が鮮明に感じられることがあります。",
          },
        ],
      },
  
      quote: {
        textLines: [
          "男性服を、",
          "もう一度発明する。",
        ],
      },
  
      whyRent: {
        label: "06 / WHY RENT?",
        titleLines: [
          "初めてのCOMME des GARCONS HOMME PLUSほど、",
          "レンタルと相性がいい。",
        ],
        items: [
          {
            number: "01",
            title: "写真では、分量と重心が読み切れない",
            text:
              "COMME des GARCONS HOMME PLUSは平面で見るだけでは魅力が伝わりにくい服が多いです。身体に乗せることで、丈、幅、布量の意味が分かります。",
          },
          {
            number: "02",
            title: "難しそうな服ほど、意外に馴染むことがある",
            text:
              "強い造形に見えても、実際に着ると自分の体格や日常のスタイリングに自然に入る場合があります。",
          },
          {
            number: "03",
            title: "高額なアーカイブを、まず経験として理解できる",
            text:
              "希少性だけで判断せず、なぜこの一着に惹かれるのかを着用体験から確かめられます。",
          },
        ],
      },
  
      inventory: {
        label: "07 / AVAILABLE ARCHIVE",
        titleLines: ["Enclopediaで", "体験できるCOMME des GARCONS HOMME PLUS。"],
        body:
          "実在庫への導線は、“COMME des GARCONS HOMME PLUSを知る続き”として設計します。まず背景を理解し、次に実物で確かめる流れを作ります。",
        items: [
          {
            meta: "COMME des GARCONS HOMME PLUS / 2022AW NOMAD",
            title: "NOMAD期 縮絨テーラードジャケット",
            text:
              "自由に移動し、どこにも属さない“ノマド”の感覚を、縮絨ウールの質感とテーラリングで体感できる一着。",
            href:
              "https://www.enclopedia-official.com/product/a2e91d68-c546-4aad-bdb5-225cf3ced675",
            image:
              "media/product/1774349558.1299286a2e91d68-c546-4aad-bdb5-225cf3ced675.png",
          },
          {
            meta: "COMME des GARCONS HOMME PLUS / 2024SS Beyond reality",
            title: "リーフプリーツジャケット",
            text:
              "“現実を超える”というテーマのもと、テーラードの再構築とリーフモチーフを重ねた2024SSらしいジャケット。",
            href:
              "https://www.enclopedia-official.com/product/f62074f2-f7e3-4b81-b277-c32e536a6684",
            image:
              "media/product/1763042723.0801384f62074f2-f7e3-4b81-b277-c32e536a6684.jpg",
          },
        ],
      },
  
      faq: {
        label: "08 / FAQ",
        titleLines: ["初めての人が、", "気になりやすいこと。"],
        items: [
          {
            question:
              "COMME des GARÇONS HOMME PLUSは、どんなブランドですか？",
            answer:
              "コムデギャルソンのメンズコレクションラインで、テーラリング、身体の見え方、素材加工、装飾を大胆に再構成するブランドです。",
          },
          {
            question:
              "COMME des GARCONS HOMME PLUSと通常のコムデギャルソンは何が違いますか？",
            answer:
              "COMME des GARCONS HOMME PLUSはメンズコレクションの実験性が最も強く現れるラインの一つです。男性服の形式を前提にしながら、その型を崩し、更新します。",
          },
          {
            question:
              "初めてなら、どんなアイテムから見るのがおすすめですか？",
            answer:
              "ジャケット、パンツ、シャツなど、見慣れた男性服の形式を保ちながら、構造の違いが分かるアイテムがおすすめです。",
          },
          {
            question:
              "COMME des GARCONS HOMME PLUSは、レンタルで試す意味がありますか？",
            answer:
              "あります。写真では伝わりにくい布量、重心、立体感、着たときの違和感を確かめられるため、初めての体験と相性が良いです。",
          },
          {
            question: "レンタル後に購入もできますか？",
            answer:
              "対象アイテムは、レンタル体験を経たうえで購入相談へ進める導線を想定しています。",
          },
        ],
      },
  
      finalCta: {
        titleLines: [
          "初めてのCOMME des GARCONS HOMME PLUSを、",
          "レンタルから始める。",
        ],
        body:
          "普通のメンズ服に見えて、着ると世界が少し変わる。\nEnclopediaで、コムデギャルソン オムプリュスのアーカイブを体験してください。",
        buttonLabel: "レンタルできるCOMME des GARCONS HOMME PLUSを見る",
        buttonHref:
          "https://www.enclopedia-official.com/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
      },
    },
  };

export default article;
